import React, {Fragment} from 'react';
import {FormField, Popup} from 'components';
import {map, shorten, camelCase, useFormikContext, useFocusPopup, useNamedSelector} from 'helpers';
import css from 'components/ui/card/card.module.scss';

export function CategoryDropdown() {
  const { values: { typeId, category }, setFieldValue } = useFormikContext();
  const categories = useNamedSelector('goals.categories');
  const project = useNamedSelector('goals.project', { id: typeId });
  const popup = useFocusPopup(CategoryPopup, {
    category,
    setFieldValue,
    typeId,
    className: 'adjacent'
  });
  return (
    <FormField {...popup} label={project ? 'Project' : 'Category'} value={project || category}>
      <b className="one-liner">
        { project ? shorten(project.name, { chars: 30 }) : categories[category] }
      </b>
    </FormField>
  );
}

function CategoryPopup({ category, typeId, setFieldValue }) {
  const { premium } = useNamedSelector('session.subscription');
  const categories = useNamedSelector('goals.categories');
  const projects = useNamedSelector('goals.projects');

  const select = ({ typeId, category }) => {
    setFieldValue('category', parseInt(typeId) ? undefined : category);
    setFieldValue('typeId', typeId || '0');
  };

  return (
    <Popup.Menu>
      <Popup.Menu.SubHeading>Categories</Popup.Menu.SubHeading>
      { map(categories, (name, id) =>
        <Popup.Menu.Item key={id} pressed={!parseInt(typeId) && id == category} background={css[camelCase(id)]} onClick={() => select({ category: id })}>
          { name }
        </Popup.Menu.Item>
      ) }
      { premium && projects.length > 0 &&
        <Fragment>
          <Popup.Menu.SubHeading>Projects</Popup.Menu.SubHeading>
          { projects.map(project =>
            <Popup.Menu.Item key={project.id} pressed={project.id == typeId} onClick={() => select({ typeId: project.id })}>
              { project.name }
            </Popup.Menu.Item>
          ) }
        </Fragment>
      }
    </Popup.Menu>
  );
}
